const returnCategories = (cat) => {
  return cat.join(' ');
};

export default returnCategories;



// WEBPACK FOOTER //
// ./src/scripts/return-categories.js